export var isPhoneLike = function isPhoneLike() {
  var isIPhone = /iphone/i.test(navigator.userAgent);
  if (isIPhone) {
    return true;
  }
  // checking width with android because the tablets are android
  var isAndroid = /android/i.test(navigator.userAgent);
  if (isAndroid && window.innerWidth < 500) {
    return true;
  }
  return false;
};

export var getPlatform = function getPlatform() {
  if (/iphone/i.test(navigator.userAgent) || /ios/i.test(navigator.userAgent)) {
    return 'iOS';
  }
  if (/android/i.test(navigator.userAgent)) {
    return 'Android';
  }
  return 'Web';
};